module.exports = __webpack_public_path__ + "static/media/barnevalen.881d2091.png";